<template>
  <div class="media" @click="act">
    <b-icon icon="edit" size="is-small" class="media-left"></b-icon>
    <span>Edit metadata</span>
  </div>
</template>

<script>
import { bus } from "@/components/spaces/bus.js";

export default {
  methods: {
    act() {
      bus.$emit("editing-event");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/bulma_overrides.scss";

.media {
  font-weight: 400;
}
</style>
